import { config } from "config/index";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import _get from "lodash.get";

import { customerActions } from "stores/customer/customerActions";
import { masterActions } from "stores/master/masterActions";
import { commonActions } from "stores/common/commonActions";
import { dashboardActions } from "stores/dashboard/dashboardActions";

const mapStateToProps = (state) => {
  return {
    // common
    loginProfile: state.customer.loginProfile,
    profilePic: state.customer.profile.profilePic,

    pendingCallList: state.master.pendingCall,
    isPendingCallListLoading: state.master.loading.pendingCall,
    isPendingListInitialCalled: state.master.initialCalled.pendingCall,
    portfolioAlert: state.dashboard.portfolioAlert,
    primePortfolioAlert: state.jarvisPrime.primeDashboard.portfolioAlert,
    isKYCCompleted: state.customer.profile.isKYCCompleted,
    isReviewCount: state.customer.profile.reviewCount,
    // portfolio
    isOnboardingCompleted: state.onboarding.isOnboardingCompleted,

    // protect
    isRMSOnboardingCompleted:
      state.jarvisRMS.rmsOnboarding.isOnboardingCompleted,

    // onestock
    isOnestockOnboardingCompleted:
      state.jarvisOnestock.onestockOnboarding.isOnboardingCompleted,

    // prime
    isPrimeOnboardingCompleted:
      state.jarvisPrime.primeOnboarding.isPrimeOnboardingCompleted,

    // sentiment
    isSentimentTrackerOnboardingCompleted:
      state.sentimentTracker.sentimentTrackerOnboarding.isOnboardingCompleted,

    // PHC
    isPHCOnboardingCompleted:
      state.PHC.PHCOnboarding.isOnboardingCompleted,

    activeProductList: _get(state.customer, "loginProfile.activeProductList", [
      config.productCodes.PRIME,
      config.productCodes.PORTFOLIO,
      config.productCodes.RMS,
      config.productCodes.ONESTOCK,
      config.productCodes.SENTIMENT,
      config.productCodes.PHC
    ]),

    // verification
    emailId: state.customer.loginProfile.email,
    mobileNumber: state.customer.loginProfile.mobile,

    notifications: [
      {
        id: 1,
        isRead: false,
        title: "Rebalance Pending",
        subtitle: "You have one rebalance pending complete it now!",
        timestamp: "Just Now",
        linkText: "Rebalance Now",
        link: "/",
      },
      {
        id: 1,
        isRead: true,
        title: "New Update is Rolled Out",
        subtitle: "",
        timestamp: "15 min ago",
        linkText: "Know More",
        link: "/",
      },
      {
        id: 3,
        isRead: true,
        title: "Complete your KYC now to start growing your money",
        subtitle: "",
        timestamp: "2 days ago",
        linkText: "Complete KYC",
        link: "/",
      },
      {
        id: 4,
        isRead: false,
        title: "Rebalance Pending",
        subtitle: "You have one rebalance pending complete it now!",
        timestamp: "Just Now",
        linkText: "Rebalance Now",
        link: "/",
      },
      {
        id: 5,
        isRead: true,
        title: "New Update is Rolled Out",
        subtitle: "",
        timestamp: "15 min ago",
        linkText: "Know More",
        link: "/",
      },
      {
        id: 6,
        isRead: true,
        title: "Complete your KYC now to start growing your money",
        subtitle: "",
        timestamp: "2 days ago",
        linkText: "Complete KYC",
        link: "/",
      },
    ],
    featureConfig: state.common.featureConfig,
    // new 
    isProfileNavEnabled: !!(
      state.onboarding.isOnboardingCompleted ||
      state.jarvisRMS.rmsOnboarding.isOnboardingCompleted ||
      state.jarvisOnestock.onestockOnboarding.isOnboardingCompleted ||
      state.jarvisPrime.primeOnboarding.isPrimeOnboardingCompleted ||
      state.sentimentTracker.sentimentTrackerOnboarding.isOnboardingCompleted ||
      state.PHC.PHCOnboarding.isOnboardingCompleted
    ),
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getPortfolioPendingTransactionAction:
        dashboardActions.getPortfolioPendingTransaction,
      logoutAction: customerActions.logout,
      pendingCallAction: masterActions.getPendingCall,
      updateEmailAction: customerActions.updateEmail,
      setToast: commonActions.setToast,
      getProfile: customerActions.getProfile,
    },
    dispatch
  );

const LayoutStore = (Container) =>
  connect(mapStateToProps, mapDispatchToProps)(Container);
export default LayoutStore;
